module.exports = require("remarkable");


//////////////////
// WEBPACK FOOTER
// external "remarkable"
// module id = 532
// module chunks = 0